import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import type { CreateElement } from 'vue';
import { VNode } from 'vue';
import type { ElTree } from 'element-ui/types/tree';
import { IPSService } from '@/services/ipsServices';

@Component({
  components: {},
})
export default class ShopDisplayTree extends Vue {
  @Prop({ default: '1' })
    fieldType: string;

  $refs: {
    tree: ElTree<any, any>;
  };

  treeData: Array<ShopDisplayTreeData> = [];

  treeSelect = null;

  isDedaultExpanded = false;

  async mounted() {
    this.getTreeList();
  }

  @Watch('fieldType')
  watchFieldType(newVal) {
    this.getTreeList();
  }

  // 获取树
  async getTreeList() {
    return IPSService.gsTreeList({ postParams: { fieldType: Number(this.fieldType) } }).then(
      (res) => {
        this.treeData = res.list.map((value: ShopDisplayTreeData, index) => {
          value.name = value.sgName;
          value.label = value.name + index;
          if (value.pageList && value.pageList.length) {
            value.pageList = value.pageList.map((showValue, idx) => {
              showValue.name = showValue.showName;
              showValue.pageId = showValue.pageId || 0;
              showValue.sgId = value.sgId;
              showValue.label = value.label + idx;
              if (showValue.pageList && showValue.pageList.length) {
                showValue.pageList = showValue.pageList.map((pageValue, i) => {
                  showValue.pageId = pageValue.pageId || 0;
                  return Object.assign({}, pageValue, {
                    sgId: pageValue.sgwpId,
                    parentId: value.sgId,
                    showType: showValue.showType,
                    name: pageValue.sgwpName,
                    label: showValue.label + i,
                    fieldType: pageValue.openType ? 'OpenAd' : pageValue.fieldType,
                  });
                });
              }
              return showValue;
            });
          }
          return value;
        });
        const result = this.treeData[0] && this.treeData[0].pageList.length > 0 && this.treeData[0].pageList[0].pageList.length > 0 ? this.treeData[0].pageList[0].pageList[0] : { sgId: this.treeData[0] ? this.treeData[0].sgId : 0 };
        this.treeSelect = result;
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(result);
        });
        this.$emit('nodeClick', this.treeSelect);
      },
      () => {
        this.$emit('update:switchIsDisabled', false);
        this.$message.error('左侧树菜单获取失败！');
      },
    );
  }

  handleNodeClick(node) {
    this.$emit('nodeClick', node);
  }

  render(h: CreateElement) {
    const dedaultExpanded = this.treeData[0] && this.treeData[0].pageList.length > 0 && this.treeData[0].pageList[0].pageList.length > 0 ? this.treeData[0].pageList[0].pageList[0].label : 0;

    return h('el-tree', {
      ref: 'tree',
      attrs: {
        'highlight-current': true,
        'node-key': 'label',
        'default-expanded-keys': [!this.isDedaultExpanded ? dedaultExpanded : 0],
        'empty-text': '暂无数据',
        'data': this.treeData,
        'props': {
          children: 'pageList',
          label: 'name',
        },
      },
      on: {
        'node-click': (e) => {
          this.handleNodeClick(e);
        },
      },
    });
  }
}
